<p-table
  *ngIf="columns?.length > 0"
  class="table"
  dataKey="id"
  [filterDelay]="0"
  [globalFilterFields]="enableTableSearch? globalFilterFields: null"
  [scrollHeight]="'flex'"
  [autoLayout]="false"
  [columns]="columns"
  [selectionMode]="selectionMode"
  [rows]="rowsNumber"
  [value]="tableData"
  [selection]="selection"
  [reorderableColumns]="reorderableColumns"
  [resizableColumns]="resizableColumns && !minView"
  [columnResizeMode]="columnResizeMode"
  [scrollable]="scrollable || resizableColumns"
  [virtualScroll]="virtualScroll"
  [virtualScrollItemSize]="minView ? cardHeight : rowHeight"
  [first]="first"
  [rowHover]="true"
  [contextMenu]="cm"
  [rowTrackBy]="trackByFunction"
  [expandedRowKeys]="expandedRowKeys"
  (onRowExpand)="updateNumberOfRows({event: $event, expanded: true})"
  (onRowCollapse)="updateNumberOfRows({event: $event, expanded: false})"
  (firstChange)="onFirstChanged($event)"
  (onColReorder)="onColReorder($event)"
  (onSort)="onSortChanged($event)"
  (onRowSelect)="onRowSelected($event)"
  (onRowUnselect)="onRowDeselected($event)"
  (onContextMenuSelect)="openContext($event)"
  (onColResize)="colResize($event)"
>
  <ng-template pTemplate="emptymessage">
    <tr class="no-data-row h-100">
      <div [attr.colspan]="columns.length" [class.simple]="simple" class="d-flex align-items-center">
        <div class="no-data" [style.margin-left.px]="buttonLeft">{{noDataMessage}}</div>
      </div>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-row>
    <ng-container *ngTemplateOutlet="rowExpansionTemplate; context: {$implicit: row, lastFrame: lastRowExpanded}">
    </ng-container>
  </ng-template>
  <ng-template pTemplate="header" let-columns *ngIf="!noHeader">
    <tr class="header ui-state-default" *ngIf="!minView; else cardHeader">
      <th *ngFor="let col of columns; trackBy: trackByColFn"
          [attr.data-col-id]="col.id"
          pReorderableColumn
          smResizableColumn
          [pResizableColumnDisabled]="col?.disableDrag"
          [pReorderableColumnDisabled]="!reorderableColumns || col?.disableDrag"
          pFrozenColumn
          [frozen]="col.frozen"
          [class.disable-drag]="!reorderableColumns || col?.disableDrag"
          [class.resize-enabled]="resizableColumns"
          [class.resize-disabled]="!resizableColumns"
          [class.selected-col-header]="col?.disablePointerEvents"
          [style.min-width]="col.style?.minWidth"
          [style.max-width]="col.style?.maxWidth"
          [style.width]="col.style?.width"
      >
        <ng-container [ngSwitch]="col?.headerType">
          <ng-container *ngSwitchCase="colHeaderTypeEnum.sortFilter">
            <ng-container *ngTemplateOutlet="sortFilterTemplate; context: {$implicit: col}"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="colHeaderTypeEnum.checkBox">
            <ng-container *ngTemplateOutlet="checkboxTemplate; context: {$implicit: col}"></ng-container>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="col-header" [class.text-center]="col.textCenter">{{col.header}}</div>
          </ng-container>
        </ng-container>
      </th>
    </tr>
    <ng-template #cardHeader>
      <tr class="header">
        <th class="table-header" style="flex-basis:100%">
          <ng-container *ngTemplateOutlet="checkboxTemplate; context: {$implicit: columns?.[0]}"></ng-container>
          <div class="table-header-title ellipsis">{{minimizedTableHeader}}</div>
          <div class="table-actions">
            <div class="recent-title">
              <sm-menu header="SORTED BY " class="menu" panelClasses="light-theme">
                <div *ngFor="let col of sortableCols; trackBy: trackByColFn">
                  <sm-menu-item [itemLabel]="col.header"
                                [sortOrder]="getOrder(col.id)"
                                (itemClicked)="sortItemClick($event, col.id)"></sm-menu-item>
                </div>
              </sm-menu>
            </div>
            <ng-container *ngTemplateOutlet="cardHeaderTemplate"></ng-container>
          </div>
        </th>
      </tr>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex" let-expanded="expanded">
    <tr
      [pRowToggler]="expandableRows? rowData : null"
      [pRowTogglerDisabled]="!expandableRows"
      [pSelectableRow]="rowData"
      [pContextMenuRow]="rowData"
      [style.height.px]="minView ? this.cardHeight : this.rowHeight"
      [class.even]="(index + 1) % 2 === 0"
      [class.checked]="isRowSelected(rowData)"
      [class.simple]="simple"
      [class.contexted]="activeContextRow?.id ===rowData?.id && contextMenuOpen"
      [class.selected]="selectionMode==='single'? selection?.id === rowData?.id : selection?.includes(rowData)"
      [class.cards-table]="minView"
      [class.pointer]="!!selectionMode"
      (click)="!minView && checkClick({e: $event, data: rowData})"
      (dblclick)="!minView && checkClick({e: $event, data: rowData})"
    >
      <ng-container *ngIf="!minView; else cardBody">
        <td
          *ngFor="let col of columns; trackBy: trackByColFn; index as i"
          pFrozenColumn
          [frozen]="col.frozen"
          [class.ui-resizable-column]="resizableColumns"
          [class.cursor-default]="selectionMode===null"
          [class.simple]="simple"
          [style.min-width]="col.style?.minWidth"
          [style.max-width]="col.style?.maxWidth"
          [style.width]="col.style?.width"
          [style.flex-basis]="!resizableColumns && columnResizeMode === 'fit' && col.style?.width"
        >
          <ng-container *ngIf="bodyTemplate; else noBodyTemplate">
            <ng-container *ngTemplateOutlet="bodyTemplate; context: {$implicit: col, rowData: rowData, rowIndex: index, expanded}">
            </ng-container>
          </ng-container>
          <ng-template #noBodyTemplate>
            {{getBodyData(rowData, col)}}
          </ng-template>
        </td>
      </ng-container>
     <ng-template #cardBody>
        <td class="pointer p-0" role="button">
          <ng-container
            *ngTemplateOutlet="cardTemplate;  context: {rowData: rowData, rowNumber: index, selected:  (selectionMode==='single'? selection?.id === rowData.id :  selection?.includes(rowData))}">
          </ng-container>
        </td>
      </ng-template>
      <div
        *ngIf="rowRightClick.observed && !minView"
        (click)="$event.stopPropagation(); openContext({originalEvent: $event, data: rowData, single: true})"
        class="context-button"
        [style.--rowHeight]="rowHeight + 'px'"
        [style.left.px]="contextButtonPosition"
        [style.padding.px]="rowHeight < 42 ? 2 : 3"
      ><i data-id="3Dot Menu Button" class="al-icon al-ico-dots-v-menu" [class.sm-md]="rowHeight < 42" ></i>
      </div>
    </tr>
    <tr *ngIf="index === rowsNumber - 1 && lazyLoading && !noMoreData && !lastRowExpanded" class="table-load-more load-more-wrapper d-flex">
      <div (smScrollEnd)="autoLoadMore && loadMore()">
        <button #loadButton
                class="btn btn-cml-primary" data-id="LoadMore"
                (click)="loadMore()"
                [style.margin-left.px]="buttonLeft">
          <i *ngIf="loading && !hasExperimentUpdate" class="load-spinner"></i>
          {{hasExperimentUpdate ? 'REFRESH LIST': loading ? 'LOADING...' : 'LOAD MORE' }}
        </button>
      </div>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" let-columns>
    <ng-container *ngTemplateOutlet="footerTemplate">
    </ng-container>
  </ng-template>
</p-table>
<p-contextMenu #cm [model]="menuItems" class="d-none"></p-contextMenu>
